import { fetchWithAuth } from './fetchWithAuth'

export async function createInventorySystemProfileToVenue(
  token: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth('/v1/inventory-system-profile-to-venues', token, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
